import React from 'react';

export const AktaLogo = ({ size = 40, showText = true, textColor = '#1F135A' }) => (
  <div className="flex items-center gap-2 select-none">
    <img src="/assets/akta-logo.png" alt="Akta Wealth" style={{ height: size }} className="object-contain" />
    {showText && (
      <div className="flex flex-col leading-tight">
        <span className="text-[10px] font-semibold tracking-widest uppercase" style={{ color: textColor, opacity: 0.7 }}>Sukh · Shanti · Samruddhi</span>
      </div>
    )}
  </div>
);

export default AktaLogo;
